import BlockchainMessagesService from '~/utilities/external-api/apis/blockchainMessagesServiceApi';

export default {
    async createEIP712Message(ctx, requestBody) {
        return BlockchainMessagesService.getEIP712Message(requestBody);
    },
};
